module.exports = __webpack_public_path__ + "img/google_logo.5472f2c3.svg";